import { ReactElement } from 'react';
import { TeamIntroduction, Props } from 'NHPTemplates.mod/Form/components/team-introduction';
import { updateFormState } from 'NHPTemplates.mod/Form/utils';

export function TeamIntroductionContainer(props: Props): ReactElement {
	return <TeamIntroduction { ...props } storeUpdater={ updateFormState } />;
}
